const features = [
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    description: '支持4K超高清播放，让你看清每一个细节，享受极致视觉体验',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '离线下载',
    description: '一键下载喜欢的视频，随时随地离线观看，不受网络限制',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    description: '全球CDN加速节点，秒开视频不卡顿，流畅观看体验',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    description: '严格内容审核机制，智能推荐算法，打造绿色健康平台',
  },
  {
    icon: 'ri-user-star-line',
    title: '创作者激励',
    description: '完善的创作者扶持计划，优质内容获得更多曝光和收益',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '手机、平板、电脑无缝切换，观看记录云端同步',
  },
];

export default function FeatureSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            为什么选择黄瓜视频
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            我们致力于为用户提供最好的短视频观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-7 hover:border-accent-300 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${feature.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-foreground-900 text-base mb-2">{feature.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}